module.exports = __webpack_public_path__ + "img/securityImg5.3f2270fe.png";